// src/tabs/OficinaTab.js
import React, { useState, useEffect } from "react";
import { Hammer, Beaker, Flame, Zap, Wrench, Settings } from "lucide-react";
import GessoSubTab from "./GessoSubTab";
import RampaSubTab from "./RampaSubTab";
import BanhoSubTab from "./BanhoSubTab";
import MaquinasSubTab from "./MaquinasSubTab";
import LigasSubTab from "./LigasSubTab";
import { seedDatabase } from "../utils/dbSeeder";

export default function OficinaTab({ user, hasAccess }) {
  const [activeSubTab, setActiveSubTab] = useState(() => {
    return localStorage.getItem("oficina_active_subtab") || "gesso";
  });

  // Run DB Seed Routine on first load of the Oficina module
  useEffect(() => {
    // seedDatabase(); // Disabled as the DB is permanent and seeds are already loaded.
  }, []);

  // Save active subtab to localStorage
  useEffect(() => {
    localStorage.setItem("oficina_active_subtab", activeSubTab);
  }, [activeSubTab]);

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] w-full overflow-hidden bg-slate-50">
      
      {/* NAVEGAÇÃO DE SUB-ABAS */}
      <div className="flex px-6 pt-4 border-b border-slate-200 bg-white gap-2 shrink-0 overflow-x-auto [&::-webkit-scrollbar]:hidden">
        <button
          onClick={() => setActiveSubTab("gesso")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-bold text-xs transition-all uppercase tracking-wider whitespace-nowrap ${
            activeSubTab === "gesso"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Beaker size={15} /> Preparo de Gesso
        </button>

        <button
          onClick={() => setActiveSubTab("rampa")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-bold text-xs transition-all uppercase tracking-wider whitespace-nowrap ${
            activeSubTab === "rampa"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Flame size={15} /> Rampa de Queima
        </button>

        <button
          onClick={() => setActiveSubTab("banho")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-bold text-xs transition-all uppercase tracking-wider whitespace-nowrap ${
            activeSubTab === "banho"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Zap size={15} /> Galvanoplastia
        </button>

        <button
          onClick={() => setActiveSubTab("maquinas")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-bold text-xs transition-all uppercase tracking-wider whitespace-nowrap ${
            activeSubTab === "maquinas"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Wrench size={15} /> Controle de Máquinas
        </button>

        <button
          onClick={() => setActiveSubTab("ligas")}
          className={`flex items-center gap-2 px-4 py-2 border-b-2 font-bold text-xs transition-all uppercase tracking-wider whitespace-nowrap ${
            activeSubTab === "ligas"
              ? "border-blue-600 text-blue-600"
              : "border-transparent text-slate-500 hover:text-slate-700"
          }`}
        >
          <Settings size={15} /> Liga Metálica
        </button>
      </div>

      {/* CONTEÚDO DAS SUB-ABAS */}
      <div className="flex-1 overflow-hidden min-h-0 relative">
        {activeSubTab === "gesso" && (
          <GessoSubTab user={user} />
        )}

        {activeSubTab === "rampa" && (
          <RampaSubTab user={user} />
        )}

        {activeSubTab === "banho" && (
          <BanhoSubTab user={user} />
        )}

        {activeSubTab === "maquinas" && (
          <MaquinasSubTab user={user} />
        )}

        {activeSubTab === "ligas" && (
          <LigasSubTab user={user} />
        )}
      </div>

    </div>
  );
}
